import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { callGetAllProvince, callGetDistrict, callGetVehicleBrand, callUploadFile } from "../../../api/settings/service"
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import DashboardHeader from "../../../components/header/DashboardHeader";
import BackPrevious from "../../../components/back-previous";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import "../../../components/i18n/lang";
import { decodeBase64, displayUrl, calculateAge, dateToString, FormatCurrencys, convertStringToJson } from "../../../utils/commonUtil"
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import DataAutoComplete from "../../../components/auto-complete";
import { addVehicleCaseIdioms, callGetActivePackage, callGetContractByKey, callgetVehicleCaseIdiomsById, updateVehicleCaseIdioms } from "../../../api/contract/service";
import SwalAlert from "../../../components/common/alert";
import context from "react-bootstrap/esm/AccordionContext";
import SmartTable from "../../../components/common/table-component";
import { callGetVehicleInsuranceClaiming } from "../../../api/insurances/service";
import { DocumentPreviewUI } from "../../../components/document-preview";

const Index = () => {
	const userInfo = useSelector((state) => state.dataLogin);
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [contract, setContract] = useState([]);
	const [request, setRequest] = useState({ page: 1, maxResult: 10, contractNumber: '', updateBy: '', status: 2, reason: '', id: null, agentCode: '' });
	let params = useParams();
	let sumCol = ['claimAmount', 'customerAmount', 'targetAmount', 'deathAmount', 'hotpitalAmount', 'editerAmount']
	const columns = [
		{
			label: 'claimLifeContractNumber', key: 'contractNumber', style: { minWidth: '200px' }

		},
		{
			label: 'claimLifeStatus', style: { minWidth: '50px' }, key: 'status', render: (val) => (
				val === 1 ? <span className="badge bg-warning">{t('statusClame.' + val)}</span> :
					val === 0 ? <span className="badge bg-danger">{t('statusClame.' + val)}</span> :
						<span className="badge bg-success">{t('statusClame.' + val)}</span>
			)
		},
		{
			label: 'claimLifeRequestDate', style: { minWidth: '50px' }, key: 'carriredDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},

		{ label: 'claimLifeDescription', style: { minWidth: '200px' }, key: 'description' },

		{
			label: 'claimLifeFullName', style: { minWidth: '200px' }, key: 'firstName', render: (val, item) => (
				item.firstName + ' ' + item.lastName
			)
		},
		{
			label: 'claimAmount', style: { minWidth: '200px' }, key: 'claimAmount', render: (val) => (
				FormatCurrencys(val)
			)
		},
		{
			label: 'claimVehicleDeadDate', style: { minWidth: '50px' }, key: 'deadDate', render: (val) => (
				val ? dateToString(val, 'DD/MM/YYYY') : '-'
			)
		},
		{
			label: 'claimVehicleReason', style: { minWidth: '150px' }, key: 'claimCause', render: (val) => (
				val ? t('causeList.' + val) : '-'
			)
		},
		{
			label: 'claimVehicleDescriptionUser', style: { minWidth: '200px' }, key: 'descriptionUser', render: (val) => (
				val ?  val : '-'
			)
		}
		, {
			label: 'claimVehicleDocument', key: 'documentPath', render: (val) => {
				try {
					return val && <DocumentPreviewUI documents={val} variant="cell" />
				} catch (error) {
					return ''
				}
			}
		},
	];
	useEffect(() => {
		if (Object.keys(params).length > 0) {
			let id = decodeBase64(params?.id)
			if (id != null) {
				loadData(null, id);
			}
		}
	}, []);

	const loadData = async (e, contract) => {
		let data = {
			page: request.page,
			maxResult: request.maxResult,
			contractNumber: contract,
			status: '',
			fromDate: '',
			toDate: '',
			sumCol: ['claim_amount', 'customer_amount', 'target_amount', 'death_amount', 'hotpital_amount', 'editer_amount']
		};
		console.log(request)
		if (e) {
			setRequest((prev) => ({
				...prev,
				page: e.page,
				maxResult: e.maxResult
			}));
			data.page = e.page
			data.maxResult = e.maxResult
		}
		const rsp = await dispatch(callGetVehicleInsuranceClaiming(data));
		if (rsp?.payload?.responseCode === "00000") {
			console.log(rsp.payload.data)
			setContract(rsp.payload.data)
		}

	}


	return (
		<div className="page-wrapper dashboard">
			<span className="header-span"></span>
			<DashboardHeader />
			<MobileMenu />
			<DashboardEmployerSidebar />
			<section className="user-dashboard">
				<div className="dashboard-outer">
					<div className="upper-title-box back-title-group">
						<BackPrevious />
						<h4>{t("contracts.detail")}</h4>
					</div>
					<div className="ls-widget">
						<div className="tabs-box">
							<div className="widget-content p-4">
								<div className="default-form">
									<SmartTable columns={columns} data={contract} keyword={request.keyword} onLazyLoad={e => { loadData(e, request.contractNumber) }}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<CopyrightFooter />
		</div>
	);
};

export default Index;
